<script>
import Navbar from "@/components/navbar";
import Service from "@/components/services";
import Cities from "@/components/cities";
import Paths from "@/components/paths";
import Blog from "@/components/blog";
import Contact from "@/components/contact";
import Footer from "@/components/footer";


/**
 * Index-1
 */
export default {
  components: {Navbar, Service, Cities, Paths, Blog, Contact, Footer},
  methods: {
    copy_ip() {
      navigator.clipboard.writeText('game.pfc-online.xyz');
      this.$toast.success("Адрес скопирован!", {
        position: "top-right",
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false
      });
    }
  }
};
</script>

<template>
  <div>
    <Navbar/>
    <div v-scroll-spy>
      <!-- Hero Start -->
      <section
          class="hero-1-bg"
          :style="{'background-image': 'url(' + require('@/assets/images/hero-1-bg-img.png') + ')'}"
          id="home"
      >
        <div class="container">
          <div class="row align-items-center justify-content-center">
            <div class="col-lg-6">
              <h1
                  class="hero-1-title text-dark font-weight-bold text-shadow mb-4"
              >Сервер с душой творца</h1>
              <div class="w-75 mb-5 mb-lg-0">
                <p class="text-muted font-size-17 mb-5 pb-5 font-size-17">
                  Мы создали современный и быстрый сервер с отличным железом и набором плагинов и механик,
                  которые вас точно заинтересуют.
                </p>
                <p class="font-size-17">
                  Нажимай, чтобы скопировать и скорее играть. Версия майнкрафта - 1.17.1!<span
                    class="font-size-20 mr-2">😉</span>
                </p>
                <div class="subscribe-form">
                  <form action="#">
                    <input type="text" value="game.pfc-online.xyz" disabled/>
                    <button type="button" @click="copy_ip()" class="btn btn-primary">Скопировать</button>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-10">
              <div class="mt-5 mt-lg-0">
                <img src="@/assets/images/hero-1-img.png" alt class="img-fluid d-block mx-auto"/>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Hero End -->
      <Service/>
      <Cities/>
      <Paths/>
<!--      <Blog/>-->
<!--      <Contact/>-->
      <Footer/>
    </div>
  </div>
</template>
